export const STORAGE_KEYS = {
  HMAC_HEADERS: "hmac_headers",
  JWT_TOKEN: "authToken"
} as const;
